import { Point } from './Point';

const sortPointsByDistanceTo = (target: Point, points: Point[]): Point[] => {
    const distances = points.map(p => target.distanceTo(p));
    const sorted = [...points].sort((a, b) => distances[points.indexOf(a)] - distances[points.indexOf(b)]);
    return sorted;
};

const sortByDistanceTo = <T>(target: Point, things: T[], pointGetter: (t: T) => Point): T[] => {
    const distances = things.map(t => target.distanceTo(pointGetter(t)));
    const sorted = [...things].sort((a, b) => distances[things.indexOf(a)] - distances[things.indexOf(b)]);
    return sorted;
};

const nearestTo = <T>(target: Point, things: T[], pointGetter: (t: T) => Point): T => {
    return sortByDistanceTo(target, things, pointGetter)[0];
};

const nearestPointTo = (target: Point, points: Point[]): Point => {
    return sortPointsByDistanceTo(target, points)[0];
};

const furthestPointFrom = (target: Point, points: Point[]): Point => {
    return sortPointsByDistanceTo(target, points).reverse()[0];
};

export const GeomUtil = {
    sortByDistanceTo,
    sortPointsByDistanceTo,
    nearestPointTo,
    nearestTo,
    furthestPointFrom
};
